import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ExtraOptions, NoPreloading, RouterModule } from '@angular/router';
import { MarkdownModule } from 'ngx-markdown';
import { FuseModule } from '@fuse';
import { FuseConfigModule } from '@fuse/services/config';
import { CoreModule } from 'app/core/core.module';
import { appConfig } from 'app/core/config/app.config';
import { LayoutModule } from 'app/layout/layout.module';
import { AppComponent } from 'app/app.component';
import { appRoutes } from 'app/app.routing';
import { API_BASE_URL } from 'Nswag/nswag-api-auth';
import { API_BASE_URL as API_BASE_URL_PIIMA_JOB } from 'Nswag/nswag-api-pimmaJob';
import { environment } from 'environments/environment';
import { FuseLoadingBarModule } from '@fuse/components/loading-bar';
import { ConfirmationService, MessageService } from 'primeng/api';
import { SpModule } from './core/Services/sp.module';
import { ToastModule } from 'primeng/toast';
import { FuseLoadingService } from '@fuse/services/loading';

const routerConfig: ExtraOptions = {
  preloadingStrategy: NoPreloading,
  scrollPositionRestoration: 'enabled',
  useHash: true,
};

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    CoreModule,
    RouterModule.forRoot(appRoutes, routerConfig),

    // Fuse, FuseConfig & FuseMockAPI
    FuseModule,
    FuseConfigModule.forRoot(appConfig),

    // Layout module of your application
    LayoutModule,
    FuseLoadingBarModule,

    // 3rd party modules that require global configuration via forRoot
    MarkdownModule.forRoot({}),

    SpModule,
    ToastModule,
  ],
  bootstrap: [AppComponent],
  providers: [
    {
      provide: API_BASE_URL,
      useValue: environment.API_BASE_URL,
    },
    {
      provide: API_BASE_URL_PIIMA_JOB,
      useValue: environment.API_BASE_URL,
    },
    MessageService,
    FuseLoadingService,
    ConfirmationService,
  ],
})
export class AppModule {}
